import './instrument';
// Startup point for client side application
import React, { StrictMode } from 'react';

import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import IEErrorPage from '@src/containers/errors/IEErrorPage';
import { isIE } from '@src/utils/browser-detect';


import { AppRoutes } from './routes';
import store from './store';

// Omit onCaughtError: Sentry.ErrorBoundary already captures boundary errors.
// Wiring both would double-report to Sentry.
const root = createRoot(document.querySelector('#root'), {
    onUncaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
});

if (isIE) {
    root.render(<IEErrorPage />);
} else {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                retry: false,
            },
        },
    });

    const s = store();

    root.render(
        <StrictMode>
            <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
                <QueryClientProvider client={queryClient}>
                    <Provider store={s}>
                        <BrowserRouter>
                            <AppRoutes />
                        </BrowserRouter>
                    </Provider>
                </QueryClientProvider>
            </Sentry.ErrorBoundary>
        </StrictMode>,
    );
}
